import React from 'react';

import { BaseWidgetProps } from '../utils/type';

interface GridProps extends BaseWidgetProps {
  id?: string,
  xGutter?: number;
  col?: number[];
  yGutter?: number;
  justify?: 'start' | 'center' | 'end';
  align?: 'start' | 'center' | 'end';
  className?: string;
}

function Grid(props: GridProps) {
  const { id, children = [], style = {}, xGutter = 0, col = [], yGutter = 0, justify, align, className = '' } = props;

  const tempStyle = { ...style };

  if ((!children || (Array.isArray(children) && children.length === 0)) && !tempStyle.height) {
    // 默认给个高度 否则无法撑开
    tempStyle.height = '60px';
  }

  // 水平
  let justifyContent: any = justify;

  if (justifyContent === 'end' || justifyContent === 'start') {
    justifyContent = `flex-${justifyContent}`;
  }

  // 垂直
  let alignItems: any = align;

  if (alignItems === 'end' || alignItems === 'start') {
    alignItems = `flex-${alignItems}`;
  }

  const rowStyle = {
    justifyContent,
    alignItems,
  };

  const cls = `cr-grid ${className}`;

  return (
    <div
      id={id}
      style={{ ...tempStyle, ...rowStyle }}
      className={cls}
    >
      {React.Children.map(children, (child, index) => {
        const { length } = col;
        const count = col.reduce((a, b) => (a + b));
        const flex = ((col[index % length] / count) || 1) * 100;
        const colStyle = {
          flex: `0 0 ${flex}%`,
          paddingLeft: xGutter / 4,
          paddingRight: xGutter / 4,
          paddingTop: yGutter / 2,
          overflow: 'hidden',
        };
        return <div className="col" style={colStyle}>{child}</div>;
      })}
    </div>
  );
}

export default Grid;
